// extracted by mini-css-extract-plugin
export default {"background":"KVOOnesxdnlvP1TKs9UDo","navBackground":"_3VMtIqP4VAGOnYcdg3RnD8"};